




































































































































































































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, ref } from "@vue/composition-api";
import * as api from "../data/api";
import { ToastType, UseToast } from "@/components/root/toast/toast.state";
import Spinner from "@/components/Spinner.vue";
import { UseLoading } from "@/common/composition/loading";
import { LabelTeachStatus } from "../data/model";
import Processing from "@/components/table/Processing.vue";
import ExistingTeachStatus from "./ExistingTeachStatus.vue";
import { UseTabs } from "@/common/composition/use-tabs";
import { UseEntities } from "@/common/composition/entities";
import { POPULATION_TYPE } from "@/common/models";
import FolderPath from "@/components/transfer/FolderPath.vue";
import LinearLoader from "@/components/LinearLoader.vue";
import { delayBy } from "@/fp";
type FolderPathStatus = "idle" | "checking" | "bad" | "good";

export default Vue.extend({
  components: {
    Modal,
    Spinner,
    Processing,
    ExistingTeachStatus,
    FolderPath,
    LinearLoader,
  },
  // labelId , is_new
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "75rem",
      withTopRightCloseBtn: true,
      height: "55rem",
    };
    const mode = ref<"new" | "existing" | "success">("new");
    const teach_label_status = ref<LabelTeachStatus | null>(null);
    const folder_path = ref("");
    const last_bad_folder_path = ref("");
    const folder_path_err = ref("");
    const folder_path_status = ref<FolderPathStatus>("idle");
    const folder_paths = ref<{ path: string; count: number }[]>([]);
    const indexed_folder_paths = computed(() => {
      return folder_paths.value.reduce((acc, { path }) => {
        acc[path] = true;
        return acc;
      }, {} as { [key: string]: boolean });
    });

    const {
      displayItems: search_display_items,
      isSearching,
      query,
      reset: reset_search,
    } = UseEntities({
      population: POPULATION_TYPE.FOLDER,
    });

    const [tabs, selected_tab, set_selected_tab] = UseTabs(
      [
        { id: "folders", name: "Folders" },
        { id: "sites", name: "Sites" },
      ],
      0
    );

    const show_err_msg = computed(() => {
      return (
        is_current_typed_path_exists.value ||
        (folder_path_err.value != "" &&
          folder_path.value == last_bad_folder_path.value)
      );
    });

    const indexed_paths = computed(() => {
      return folder_paths.value.reduce((acc, { path }) => {
        acc[path] = true;
        return acc;
      }, {} as { [key: string]: boolean });
    });

    const is_current_typed_path_exists = computed(() => {
      return indexed_paths.value[folder_path.value];
    });

    const add_folder_path_from_search = (path: string) => {
      folder_path.value = path;
      if (is_current_typed_path_exists.value) {
        UseToast().show({
          type: ToastType.ALERT,
          msg: "This path already exists",
          duration: 2000,
        });
        return;
      }
      reset_search();
      add_folder_path();
    };

    const add_folder_path = async () => {
      if (folder_path.value.trim() == "") return;
      folder_path_status.value = "checking";
      folder_path_err.value = "";
      const res = await api.send_folder_path_to_analysis(folder_path.value);
      if (res.success) {
        if (res.value.ok) {
          folder_path_status.value = "good";
          folder_paths.value = [
            ...folder_paths.value,
            { path: folder_path.value, count: res.value.count },
          ];
          folder_path.value = "";
          reset_search();
          setTimeout(() => {
            folder_path_status.value = "idle";
          }, 400);
        } else {
          folder_path_status.value = "bad";
          folder_path_err.value = res.value.reason;
          last_bad_folder_path.value = folder_path.value;
          setTimeout(() => {
            folder_path_status.value = "idle";
          }, 400);
        }
      } else {
        // show error toast
        UseToast().show({
          type: ToastType.ALERT,
          msg: "Something went wrong, please try again",
          duration: 4000,
        });
      }
    };

    const remove_folder_path = (index: number) => {
      folder_paths.value = folder_paths.value.filter((_, i) => i !== index);
    };
    const [is_sending_folders, set_is_sending_folders] = UseLoading(
      false
    ).as_arr();
    const start_label_teach = async (event: MouseEvent) => {
      set_is_sending_folders(true);
      const res = await api.send_folders_for_label_teach({
        folders: folder_paths.value.map((path) => path.path),
        // @ts-ignore
        label_id: props.modalData.label_id,
      });
      set_is_sending_folders(false);
      if (res.success) {
        mode.value = "success";
      } else {
        UseToast().show({
          type: ToastType.ALERT,
          msg: "Something went wrong, please try again",
          duration: 4000,
          relative_to: {
            el: event.target as HTMLElement,
            position: "top",
          },
        });
      }
    };

    const load_data = async () => {
      // @ts-ignore
      const res = await api.get_label_teach_status(props.modalData.label_id);
      if (res.success) {
        mode.value = res.value.folders.length > 0 ? "existing" : "new";
        teach_label_status.value = res.value;
        const has_running_folders = res.value.folders.some((d) => d.is_running);
        if (has_running_folders) {
          await delayBy(3000);
          load_data();
        }
      }
    };

    const load_label_teach_status = async () => {
      set_is_loading(true);
      await load_data();
      set_is_loading(false);
    };

    const [is_loading, set_is_loading] = UseLoading(false).as_arr();

    onMounted(async () => {
      // @ts-ignore
      const { is_new } = props.modalData;
      if (!is_new) {
        await load_label_teach_status();
      }
    });

    return {
      mode,
      config,
      tabs,
      selected_tab,
      set_selected_tab,
      is_loading,
      folder_path,
      folder_paths,
      indexed_folder_paths,
      add_folder_path,
      add_folder_path_from_search,
      show_err_msg,
      remove_folder_path,
      start_label_teach,
      folder_path_status,
      folder_path_err,
      is_current_typed_path_exists,
      is_sending_folders,
      teach_label_status,
      // search
      search_display_items,
      isSearching,
      query,
      reset_search,
      load_label_teach_status,
    };
  },
});
